import React from 'react';
import './CTA.css';

const ZOHO_FORM_URL =
  'https://forms.voiceofhealthcare.org/voiceofhealthcare/form/BestWorldCollaboration/formperma/G79LAnFpezW8gJwA8uQ0mohHI91wob6r5tK8mtovAbA';

function CTA() {
  return (
    <section id="contact" className="section-padding cta">
      <div className="container">
        <h2 className="section-title reveal cta__title">Let's Work Together</h2>

        <p className="description-text reveal cta__text">
          Whether you're launching a product, building a therapy area, or engaging
          stakeholders — we help you do it with precision and impact.
        </p>

        <div className="cta__contact-info reveal">
          <a href="mailto:info@healthnext.co.in" className="cta__contact-link">
            📩&nbsp; info@healthnext.co.in
          </a>
          <span className="cta__contact-sep">|</span>
          <a href="tel:+919599193575" className="cta__contact-link">
            📞&nbsp; +91-95991 93575
          </a>
        </div>

        <div className="cta__buttons reveal">
          <a
            href={ZOHO_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-main cta__btn-white"
          >
            Contact Us
          </a>
          <a
            href={ZOHO_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-main cta__btn-outline"
          >
            Schedule Consultation
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTA;
